import { Button, Box, keyframes } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
const loadingBar = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

interface ILoadingButtonProps {
    loading: boolean;
    disabled: boolean;
    onClick: () => void;
    label: string;
    sx?: SxProps<Theme>;
}

const LoadingButton: React.FC<ILoadingButtonProps> = ({ loading, disabled, onClick, label, sx }) => {
    return (
        <Button
            variant="contained"
            disabled={disabled || loading}
            onClick={onClick}
            sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "999px",
                textTransform: "none",
                px: 3,
                color: "white",
                backgroundColor: loading ? "primary.main" : undefined,
                ...(sx || {}),
            }}
        >
            {loading && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)",
                        animation: `${loadingBar} 1.2s linear infinite`,
                        zIndex: 1,
                        pointerEvents: "none",
                    }}
                />
            )}

            <Box sx={{ position: "relative", zIndex: 2 }}>{label}</Box>
        </Button>
    );
};

export default LoadingButton;
